import { render, staticRenderFns } from "./BlockrainGame.vue?vue&type=template&id=1c319982"
import script from "./BlockrainGame.vue?vue&type=script&lang=js"
export * from "./BlockrainGame.vue?vue&type=script&lang=js"
import style0 from "./BlockrainGame.vue?vue&type=style&index=0&id=1c319982&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports